function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  fill: "#FFD561",
  x: 0,
  y: 0,
  width: 73,
  height: 73,
  rx: 22
}), /*#__PURE__*/React.createElement("text", {
  id: "$",
  transform: "translate(24.000000, 22.500000) rotate(-30.000000) translate(-24.000000, -22.500000) ",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 10,
  fontWeight: "bold",
  "line-spacing": 7,
  fill: "#6D1C6C"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 15.4,
  y: 23.8399658
}, "$")), /*#__PURE__*/React.createElement("text", {
  id: "$-copy",
  transform: "translate(34.000000, 16.500000) rotate(-10.000000) translate(-34.000000, -16.500000) ",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 14,
  fontWeight: "bold",
  "line-spacing": 7,
  fill: "#6D1C6C"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 21.96,
  y: 16.9759521
}, "$")), /*#__PURE__*/React.createElement("g", {
  id: "man-user",
  transform: "translate(24.000000, 24.000000)",
  fill: "#75318C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.0000851,15 C15.3136069,15 18,11.642169 18,7.50004382 C18,3.35783097 17.1180177,0 12.0000851,0 C6.88215259,0 6,3.35783097 6,7.50004382 C6,11.642169 8.68639305,15 12.0000851,15 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.00069282,26.0634755 C0.99949282,25.816447 0.99829282,25.9938755 1.00069282,26.0634755 L1.00069282,26.0634755 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9989918,26.1121959 C24.0027918,26.0445673 24.0002918,25.6429959 23.9989918,26.1121959 L23.9989918,26.1121959 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9871251,25.5065308 C23.8743613,18.3363811 22.945119,16.2932776 15.8342638,15 C15.8342638,15 14.833302,16.2853535 12.5002592,16.2853535 C10.1672164,16.2853535 9.16608184,15 9.16608184,15 C2.13282189,16.279171 1.14706811,18.2919714 1.01745462,25.273598 C1.00682631,25.8436956 1.001901,25.8736503 1,25.8074713 C1.00043204,25.9314699 1.0009505,26.1608325 1.0009505,26.5607802 C1.0009505,26.5607802 2.69387548,30 12.5002592,30 C22.3064702,30 23.999568,26.5607802 23.999568,26.5607802 C23.999568,26.303814 23.9997408,26.1251306 24,26.0035702 C23.998099,26.0444967 23.994297,25.9651689 23.9871251,25.5065308 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "close",
  transform: "translate(47.000000, 43.000000) scale(-1, -1) translate(-47.000000, -43.000000) translate(42.000000, 38.000000)",
  fill: "#DC7B53",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.91614962,5.00007414 L9.80994863,1.10607568 C10.0633505,0.852787223 10.0633505,0.443254799 9.80994863,0.189966342 C9.55666543,-0.0633221141 9.14714151,-0.0633221141 8.89385831,0.189966342 L4.99994067,4.08396483 L1.10614169,0.189966342 C0.852739861,-0.0633221141 0.443334566,-0.0633221141 0.190051368,0.189966342 C-0.063350456,0.443254799 -0.063350456,0.852787223 0.190051368,1.10607568 L4.08385038,5.00007414 L0.190051368,8.89407262 C-0.063350456,9.14736108 -0.063350456,9.5568935 0.190051368,9.81018196 C0.316277745,9.93652958 0.482246456,10 0.648096542,10 C0.813946597,10 0.979796682,9.93652958 1.10614169,9.81018196 L4.99994067,5.91618347 L8.89385831,9.81018196 C9.02020332,9.93652958 9.1860534,10 9.35190349,10 C9.51775354,10 9.6836036,9.93652958 9.80994863,9.81018196 C10.0633505,9.5568935 10.0633505,9.14736108 9.80994863,8.89407262 L5.91614962,5.00007414 Z",
  id: "Path"
}))));

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.07ae3623.svg";
export { ForwardRef as ReactComponent };